/**
 * @fileoverview Endless Runner Module Exports
 * @description Public API for the Endless Runner game module
 */

// Types
export * from "./types";

// Hooks
export { useEndlessRunner } from "./hooks/useEndlessRunner";

// Components
export { GameCanvas } from "./components/GameCanvas";
export { RunnerDifficultyCard } from "./components/RunnerDifficultyCard";
export { RunnerResultOverlay } from "./components/RunnerResultOverlay";
export { RunnerLeaderboard } from "./components/RunnerLeaderboard";
export { CharacterPicker } from "./components/CharacterPicker";

